export const FIND_ALL = `${process.env.REACT_APP_API_URL}/levels`;

export const GET_LEVELS_BY_ID = (idLevel: any) =>
  `${process.env.REACT_APP_API_URL_RESSOURCES}/levels/${idLevel}`;
